module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ap68w"))).then(() => parcelRequire('hEqeo'));